import * as types from "../actions/actionTypes";
import { getAllRequirementsResponse, getRequirementByIdResponse } from "../actions";
import { createEntitySagas } from "./sagaHelpers";

export const requirementEntity = createEntitySagas({
  entity: "requirement",
  endpoint: "requirements",
  label: "Requirement",
  scope: "company",
  computedFields: ["brandName","manufacturerName","engagementName","coordinator","lastUpdated"],
  selectSlice: (state) => state.requirement,
  listKey: "requirements",
  types: {
    getAll: types.GET_ALL_REQUIREMENTS,
    getById: types.GET_REQUIREMENT_BY_ID,
    create: types.CREATE_REQUIREMENT,
    update: types.UPDATE_REQUIREMENT,
    remove: types.DELETE_REQUIREMENT,
  },
  actions: { getAllResponse: getAllRequirementsResponse, getByIdResponse: getRequirementByIdResponse },
});

export const requirementSaga = requirementEntity.watcher;
